import axios from 'axios';
import https from 'https';

const grispiApiBasic = axios.create({
    baseURL: process.env.NEXT_PUBLIC_BASE_URL
});

grispiApiBasic.defaults.headers.common['Grispi'] = 'u'; //https://palmda.atlassian.net/jira/software/c/projects/GRISPI/boards/7?selectedIssue=GRISPI-2631

grispiApiBasic.defaults.headers.post['Content-Type'] = 'application/json';
grispiApiBasic.defaults.headers.put['Content-Type'] = 'application/json';

if (process.env.NODE_ENV === 'development') {
    axios.defaults.httpsAgent = new https.Agent({
        rejectUnauthorized: false
    });
}

export default grispiApiBasic;
